import { CardBody, CardFooter } from '@execonline-inc/execonline-ui';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import ExperienceCardBody from '../../../../../../CurrentCollectionStep/BuilderV2/ExperienceCardBody';
import ExperienceFooter from '../../../../../../CurrentCollectionStep/BuilderV2/ExperienceFooter';
import { ExperienceResource } from '../../../../../../CurrentCollectionStep/BuilderV2/Types';
import ExperienceVideoState from '../../../../../../ExperienceVideoState';
import ExperienceCardHeader from './ExperienceCardHeader';
import ExperienceSchoolThumbnail from './ExperienceSchoolThumbnail';

export interface Props {
  experienceResource: ExperienceResource;
}

function CardContent({ experienceResource }: Props) {
  return (
    <div className="box-border h-full flex w-full sm:max-w-full xl:min-w-[15rem] xl:max-w-[26.625rem]">
      <div tabIndex={-1} className="relative flex w-full flex-col overflow-visible">
        <div
          data-testid="execonline-card"
          data-intercom-target="experience-card"
          className={clsx(
            'rounded text-gray-800 box-border w-full flex-grow',
            'shadow-card relative flex flex-col',
            'w-86 bg-white md:w-88',
          )}
        >
          <ExperienceVideoState
            experienceResource={experienceResource}
            className="h-[11.125rem] w-full flex-none rounded-t"
          >
            <ExperienceSchoolThumbnail experienceResource={experienceResource} />
          </ExperienceVideoState>
          <ExperienceCardHeader experienceResource={experienceResource} />
          <CardBody>
            <ExperienceCardBody experienceResource={experienceResource} />
          </CardBody>
          <CardFooter>
            <ExperienceFooter experienceResource={experienceResource} />
          </CardFooter>
        </div>
      </div>
    </div>
  );
}

export default observer(CardContent);
